import { isProcessClient } from "~/utils/process"
import { AnalyticsLayer } from "./analytics"

type ShWindow = Window & typeof globalThis & {
  sohohouse?: AnalyticsLayer
}

const shWindow = (isProcessClient() ? window : {}) as ShWindow

export default shWindow
